<template>
    <div class="pageDown">
        <img src="../../assets/img/b2b/dfxlogo_72@2x.png" alt="">
        <h2>单分享</h2>
        <div class="btnDown" @click="onDownDfx">立即下载</div>
        <div class="btnOpen" @click="onOpenDfx">已安装,立即打开</div>
    </div>
</template>
<script>
import { Toast } from 'mint-ui'
import { buryPoint, getNewApk } from '../b2b/api/api'
export default {
    data () {
        return {
            type: this.$route.query.type,
            id: this.$route.query.id,
            apkHerf: ''
        }
    },
    methods: {
        onDownDfx () {
            this.buryPoint(95)
            var u = navigator.userAgent
            var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1 // g
            var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) // ios终端
            if (isAndroid) {
                if (this.apkHerf) {
                    window.location.href = this.apkHerf
                } else {
                    Toast('暂无有效版本下载')
                }
            }
            if (isIOS) {
                window.location.href = 'itms-apps://itunes.apple.com/app/id1481422393'
            }
        },
        async buryPoint (event) {
            await buryPoint({
                type: 5,
                dfx_type: 1,
                event: event
            })
        },
        onOpenDfx () {
            let route = ''
            route = `/b2b/specialActivity/index?id=${this.id}`
            window.location.href = 'dfx://showB2bpage?route=' + route
        },
        async findApk () {
            const { data } = await getNewApk({ product: 1, platformType: 1 })
            // if (data.data) {
            //     this.apkHerf = data.data
            // } else {
            //     Toast('暂无有效版本下载')
            // }
            this.apkHerf = data.data
        }
    },
    mounted () {
        this.buryPoint(94)
        this.onOpenDfx()
        this.findApk()
    }
}
</script>
<style lang="scss" scoped>
.pageDown {
    overflow: hidden;
    img {
        width: 144px;
        height: 144px;
        margin: 320px auto 0 auto;
        display: block;
    }
    h2 {
        font-size: 40px;
        text-align: center;
        margin-top: 20px;
    }
    .btnDown {
        width: 494px;
        height: 96px;
        background: #ff7a45;
        color: #fff;
        border-radius: 60px;
        margin: 40px auto;
        font-size: 35px;
        text-align: center;
        line-height: 96px;
    }
    .btnOpen {
        width: 494px;
        height: 96px;
        background: #fff;
        color: #ff7a45;
        border-radius: 60px;
        margin: 40px auto;
        font-size: 35px;
        text-align: center;
        line-height: 96px;
    }
}
</style>